import React, { FC } from 'react';
import { Box } from '@mantine/core';

import cx from './Section.module.css';

const SectionSpacer: FC<{ size?: 'xs' | 'sm' | 'lg' }> = ({ size = 'lg' }) => (
    <Box className={cx.sectionSpacer} data-size={size} />
);

export { SectionSpacer };
